/*---------------------------------------------------------------------------*
 *  PubliOne JS
 *---------------------------------------------------------------------------*
 *
 *  This is the main scripts file.
 *
 *  Author: PubliOne S.r.l.
 *  Author URI: http://publione.it
 *
 *  @version  4.0.0
 *
 *
 *  These scripts are prepended and bundled with this one. Should the build
 *  system ever change, be sure to include these scripts first.
 *
 *  - modules/lava-menu/lava-menu.js
 *
 */

( function ( window, document, WP, undefined ) {

  var UI = {

    init: function() {
      new DOMToggler();
      new LavaMenu( '.js-lavaMenu' );
    },

    refresh: function() {
    }
  };

  window.addEventListener( 'load', UI.init );

} )( window, window.document, window.WP );
